import React from 'react';

import { LoadingContainer } from 'app/components/LoadingContainer';
import { lazyLoad } from 'utils/loadable';

export const Agent = lazyLoad(
  () => import('./index'),
  module => module.AgentPage,
  { fallback: <LoadingContainer loading /> },
);
